import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SemovelProvider } from '../../providers/semovel/semovel';

@Component({
  selector: 'page-busca-produto',
  templateUrl: 'busca-produto.html',
})
export class BuscaProdutoPage {

  produtos: Array<{nome: string, embalagem:string, preco: number, imagem:string, id:number, url_imagem:string}>;
  backup: Array<{nome: string, embalagem:string, preco: number, imagem:string, id:number, url_imagem:string}>;

  constructor(public navCtrl: NavController, public navParams: NavParams, public server: SemovelProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BuscaProduto');

    this.produtos = [];
           
    let request = { method: 'movel/produtos', params: [] };

    this.server.postData(request, {}).subscribe(data => {
      if (data) 
        this.loadList(data);
        return true;
    },

    error => {
      this.server.showError(error);          
    });
  }

  selecionar(event, produto) {
    this.server.produtoSelecionado = produto;
    this.navCtrl.pop();
  }

  filtrarProdutos(ev: any) {
    this.produtos = this.backup;
    let val = ev.target.value;

    if (val && val.trim() != '') {
      this.produtos = this.produtos.filter( (produto) => {
        return (produto.nome.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }
 
  loadList(data) {
    this.produtos = [];
    
    for(var i in data) {       
      let produto = data[i];
      produto.url_imagem = this.server.imagens+produto.imagem;
      console.log(produto.url_imagem);
      this.produtos.push(produto);
    }
    this.backup = this.produtos;
  }
}



// WEBPACK FOOTER //
// ./src/pages/busca-produto/busca-produto.ts